import { gql, TypedDocumentNode } from '@common/hooks';
import { HistoryInfoFragment } from '@common/graphql/fragments';
import {
  ProfileStatusSetupDrawerApplicationQueryQueryCgResponse,
  ProfileStatusSetupDrawerApplicationQueryQueryVariables,
  ProfileStatusSetupDrawerAssignmentQueryQueryCgResponse,
  ProfileStatusSetupDrawerAssignmentQueryQueryVariables,
} from '@common/graphql';

export type ProfileStatusSetupDrawerApplicationType =
  ProfileStatusSetupDrawerApplicationQueryQueryCgResponse['staffingRequestApplication'];

export const PROFILE_STATUS_SETUP_DRAWER_APPLICATION_QUERY: TypedDocumentNode<
  ProfileStatusSetupDrawerApplicationQueryQueryCgResponse,
  ProfileStatusSetupDrawerApplicationQueryQueryVariables
> = gql`
  ${HistoryInfoFragment}
  query ProfileStatusSetupDrawerApplicationQuery($id: ID!) {
    staffingRequestApplication(id: $id) {
      id
      doNotRehire
      worksProfile {
        id
        identificationCode
        fullName
      }
      organization {
        id
        name
      }
      organizationBusiness {
        id
        name
      }
      organizationUnit {
        id
        name
      }
      profileStatusHistory {
        ...HistoryInfoFragment
      }
    }
  }
`;

export type ProfileStatusSetupDrawerAssignmentType =
  ProfileStatusSetupDrawerAssignmentQueryQueryCgResponse['staffingRequestAssignment'];

export const PROFILE_STATUS_SETUP_DRAWER_ASSIGNMENT_QUERY: TypedDocumentNode<
  ProfileStatusSetupDrawerAssignmentQueryQueryCgResponse,
  ProfileStatusSetupDrawerAssignmentQueryQueryVariables
> = gql`
  ${HistoryInfoFragment}
  query ProfileStatusSetupDrawerAssignmentQuery($id: ID!) {
    staffingRequestAssignment(id: $id) {
      id
      doNotRehire
      cancelledDetail
      worksProfile {
        id
        identificationCode
        fullName
      }
      organization {
        id
        name
      }
      organizationBusiness {
        id
        name
      }
      organizationUnit {
        id
        name
      }
      profileStatusHistory {
        ...HistoryInfoFragment
      }
    }
  }
`;

export type ProfileStatusSetupDrawerEntityType =
  | ProfileStatusSetupDrawerApplicationType
  | ProfileStatusSetupDrawerAssignmentType;
